// extracted by mini-css-extract-plugin
export default {"avatar":"SMLInitialsAvatar_avatar__doiVy"};